import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-jquery-ui',
	templateUrl:'./JQueryUIPluginPage.html',
	styles: [],
	styleUrls:['./JQueryUIPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQueryUIPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_610 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>jquery-ui</artifactId>
</dependency>
\`\`\``;
	mdContent_611 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:jquery-ui:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_612 = `\`\`\`json
"jquery-ui": "^1.14.2"
\`\`\``;
	mdContent_613 = `\`\`\`java
JQUIAccordion accordion = new JQUIAccordion();
accordion.addAccordianTab(tab1);
accordion.addAccordianTab(tab2);
accordion.getOptions().setCollapsible(true);
accordion.getOptions().getAnimate()
    .setEasing(JQEasingEffects.easeInBack);
\`\`\``;
	mdContent_614 = `\`\`\`java
JQUIDialog dialog = new JQUIDialog("My Dialog");
dialog.getOptions().setModal(true);
dialog.getOptions().setWidth(400);
dialog.getOptions().setHeight(300);
\`\`\``;
	mdContent_615 = `\`\`\`java
JQUIAutoComplete ac = new JQUIAutoComplete("search");
ac.getOptions().addOption("option 1");
ac.getOptions().setAjax(true, ac);
\`\`\``;
	mdContent_616 = `\`\`\`java
// Accordion with animation
JQUIAccordion accordion = new JQUIAccordion();
accordion.addAccordianTab(tab1);
accordion.addAccordianTab(tab2);
accordion.getOptions().setCollapsible(true);
accordion.getOptions().getAnimate()
    .setEasing(JQEasingEffects.easeInBack);

// Autocomplete with AJAX
JQUIAutoComplete ac = new JQUIAutoComplete("search");
ac.getOptions().setAjax(true, ac);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
